type EventCallback = (event: Event) => void | Promise<void>

interface EventHandler {
  handler: EventCallback;
  once: boolean;
  run: boolean;
}

export default class EventEmitter {
  #handlers: Record<string, Map<EventCallback, EventHandler>> = {};
  constructor() {
    this.addEventListener = this.addEventListener.bind(this);
    this.removeEventListener = this.removeEventListener.bind(this);
    this.dispatchEvent = this.dispatchEvent.bind(this);
  }
  addEventListener(name: string, handler: EventCallback, {once}: { once: boolean } = {once: false}) {
    if (!(this.#handlers[name] instanceof Map)) this.#handlers[name] = new Map();
    this.#handlers[name].set(handler, {handler, once, run: false});
  }

  removeEventListener(name: string, handler: EventCallback) {
    if (!(this.#handlers[name] instanceof Map)) return; // no events registered
    this.#handlers[name].delete(handler);
    if (this.#handlers[name].size === 0) delete this.#handlers[name];
  }

  async dispatchEvent(event: Event) {
    const events = this.#handlers[event.type];
    if (!(events instanceof Map)) return; // no events registered
    const deleteList: EventCallback[] = [];

    const done: Promise<void>[] = [];
    for (const [key, handler] of events) {
      try {
        const prom = (async () => handler.handler(event))();
        done.push(prom);
        prom.catch((err) => console.error('event handler failed:', err));
        handler.run = true;
        if (handler.once) deleteList.push(key);
      } catch (err) {
        console.error('event handler failed:', err);
      }
    }

    deleteList.forEach((k) => this.removeEventListener(event.type, k));

    await Promise.allSettled(done);
  }
}
